import { render, staticRenderFns } from "./GoodsCompositionList.vue?vue&type=template&id=5b99e88b&scoped=true"
import script from "./GoodsCompositionList.vue?vue&type=script&lang=js"
export * from "./GoodsCompositionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b99e88b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b99e88b')) {
      api.createRecord('5b99e88b', component.options)
    } else {
      api.reload('5b99e88b', component.options)
    }
    module.hot.accept("./GoodsCompositionList.vue?vue&type=template&id=5b99e88b&scoped=true", function () {
      api.rerender('5b99e88b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/goods/GoodsCompositionList.vue"
export default component.exports